import { Link } from "react-router-dom";
import Logo from "@/components/site/Logo";

export default function Footer({ settings }) {
    return (
        <footer
            className="bg-[#0a0a0a] border-t border-white/10"
            data-testid="site-footer"
        >
            <div className="h-1 hazard-stripes opacity-80" />
            <div className="max-w-7xl mx-auto px-5 md:px-10 py-12 grid md:grid-cols-3 gap-10">
                <div>
                    <Logo variant="compact" className="mb-4" />
                    <p className="text-zinc-400 text-sm max-w-xs">
                        Specialist used car parts and dismantling services for European
                        vehicles.
                    </p>
                </div>
                <div>
                    <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
                        Quick links
                    </div>
                    <ul className="space-y-2 text-sm">
                        <li><a href="#home" className="text-zinc-300 hover:text-white">Home</a></li>
                        <li><a href="#stock" className="text-zinc-300 hover:text-white">Stock</a></li>
                        <li><a href="#contact" className="text-zinc-300 hover:text-white">Contact</a></li>
                        <li>
                            <Link to="/admin/login" className="text-zinc-500 hover:text-white text-xs uppercase tracking-[0.2em]" data-testid="footer-admin-link">
                                Admin
                            </Link>
                        </li>
                    </ul>
                </div>
                <div>
                    <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
                        Contact
                    </div>
                    {settings && (
                        <ul className="space-y-1 text-sm text-zinc-300">
                            <li>Phone: {settings.phone}</li>
                            {settings.mobile && <li>Mobile: {settings.mobile}</li>}
                            <li>{settings.email}</li>
                            <li className="text-zinc-400">{settings.address}</li>
                        </ul>
                    )}
                </div>
            </div>
            <div className="border-t border-white/10 py-5 text-center text-[10px] uppercase tracking-[0.3em] text-zinc-500">
                © {new Date().getFullYear()} Auto Europarts. All rights reserved.
            </div>
        </footer>
    );
}
